import "./walk-in-panel";
import WalkInPanel from "./walk-in-panel";
import elt from "../../../html/elt";
import injectCSS from "../../../html/inject-css";
import { ShowWallConfig } from "../../../views/views-config";
import { registerListener } from "../../../html/register-listener";
import { uuid4 } from "../../../utils";

// TODO: this is going to miscount islands b/c it's not aware of front and back
// sides.

export class WalkInWallsPanel extends WalkInPanel {
    config: ShowWallConfig[];

    wallGrid: HTMLElement = elt('div', {class: 'walk-in-walls-grid'});

    constructor(config: ShowWallConfig[]) {
        super();
        injectCSS(STYLESHEET);

        this.config = config;
    }

    connectedCallback() {
        this.append(this.wallGrid);

        this.refresh();
    }

    show(under: HTMLElement) {
        super.show(under);
        this.refresh();
    }

    refresh = () => {
        // Empty the grid and rebuild
        this.wallGrid.replaceChildren();

        let islandNumber = 1;
        for(const wall of this.config) {
            const
                id = uuid4(),
                checked = wall.show ? {checked: "true"} : {},
                checkbox: HTMLInputElement =
                    elt('input',
                        {
                            id,
                            ...checked,
                            type: 'checkbox',
                            class: 'form-check-input',
                        }),
                n = wall.island ? String(islandNumber++) : wall.wallOrder,
                prefix = wall.island ? 'Island' : 'Wall',
                label = elt('label',
                            {
                                for: id,
                                class: "form-label",
                            },
                            `${prefix} ${n}`),
                handler = () => {
                    wall.show = checkbox.checked;
                    this.dispatchEvent(
                        new CustomEvent('wall-visibility-change',
                                        { bubbles: true }));
                }

            registerListener(checkbox, 'change', handler);

            this.wallGrid.append(checkbox, label);
        }
    };
}
export default WalkInWallsPanel;
window.customElements.define('walk-in-walls-panel', WalkInWallsPanel);

const STYLESHEET = `
walk-in-walls-panel {
    & .walk-in-walls-grid {
        display: grid;
        grid-template-columns: auto auto;
        grid-gap: 1rem;
        align-items: center;

        & input[type=checkbox], & label {
            margin: 0;
            cursor: pointer;
            user-select: none;
        }
    }
}
`;
